<template>
    <div v-if="isOpen" class="mapa-overlay">
        <div
            class="mapa-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Selecionar coordenadas"
        >
            <GoogleMap
                :api-key="googleMapsApiKey"
                :center="coordenadas"
                :zoom="14"
                :fullscreen-control="false"
                style="width: 100%; height: 100%"
                @click="selecionarCoordenada"
            >
                <Marker
                    v-if="showMarker"
                    :options="{
                        position: coordenadas,
                        draggable: true,
                    }"
                    @dragend="selecionarCoordenada"
                />
            </GoogleMap>

            <button
                type="button"
                class="mapa-fechar"
                @click="emit('close')"
            >
                <span aria-hidden="true">×</span>
                Fechar
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { GoogleMap, Marker } from "vue3-google-map";

const props = defineProps({
    isOpen: Boolean,
    coordenadasIniciais: {
        type: Object,
        default: () => ({ lat: -28.935225, lng: -49.485324 }),
    },
    showMarker: Boolean,
});

const emit = defineEmits(["coordenadaSelecionada", "close"]);

// Exemplo para projetos com Vite.
const googleMapsApiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;

const coordenadas = ref({ ...props.coordenadasIniciais });

watch(
    () => [
        props.isOpen,
        props.coordenadasIniciais.lat,
        props.coordenadasIniciais.lng,
    ],
    ([isOpen, lat, lng]) => {
        if (isOpen) {
            coordenadas.value = { lat, lng };
        }
    }
);

function selecionarCoordenada(event) {
    if (!event.latLng) return;

    coordenadas.value = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
    };

    emit("coordenadaSelecionada", { ...coordenadas.value });
}
</script>

<style scoped>
.mapa-overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: grid;
    place-items: center;
    padding: 20px;
    background: rgb(15 23 42 / 45%);
}

.mapa-modal {
    position: relative;
    width: min(1200px, 100%);
    height: 85vh;
    height: 85dvh;
    overflow: hidden;
    border-radius: 14px;
    background: white;
    box-shadow: 0 20px 60px rgb(0 0 0 / 30%);
}

.mapa-fechar {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;

    width: auto;
    min-width: 0;
    height: 40px;
    margin: 0;
    padding: 0 14px;

    border: 0;
    border-radius: 8px;
    background: white;
    color: #334155;
    font: 600 14px/1 Arial, sans-serif;
    cursor: pointer;
    box-shadow: 0 2px 8px rgb(0 0 0 / 20%);
}

.mapa-fechar:hover {
    background: #f1f5f9;
}

.mapa-fechar:focus-visible {
    outline: 3px solid #2563eb;
    outline-offset: -3px;
}

.mapa-fechar span {
    font-size: 24px;
    font-weight: 400;
}

/* Evita que a largura global de button afete os controles do Google. */
.mapa-modal :deep(.gm-style button) {
    width: auto;
    min-width: 0;
}

/* Compacta especificamente os botões Mapa/Satélite. */
.mapa-modal :deep(.gm-style .gm-style-mtc > button) {
    height: 36px !important;
    padding: 0 12px !important;
    font-size: 14px !important;
}

@media (max-width: 600px) {
    .mapa-overlay {
        padding: 10px;
    }

    .mapa-modal {
        height: 90vh;
        height: 90dvh;
        border-radius: 10px;
    }
}
</style>